<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-shopping-cart  mr-2" />Flash Sale</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Flash Sale">
                        <b-form-input placeholder="Cari nama flash sale" v-model="filter.name"
                            @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Gudang">
                        <b-form-select v-model="filter.warehouse" :options="optFilterWarehouse" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Divisi">
                        <b-form-select v-model="filter.division" :options="optFilterDivision" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Group">
                        <b-form-select v-model="filter.group" :options="optFilterGroup" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <div class="d-flex justify-content-end">
                            <b-button variant="primary" @click="getItems()">
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                            <b-button variant="success" class="ml-2" @click="$bvModal.show('m-create')">
                                <i class="fa fa-plus mr-2" />Flash Sale Baru
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data flash sale.
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.name || "-" }}<br />
                    <div v-if="row.item.status != 1" class="small text-muted">
                        Diskon: {{ row.item.discount_percentage }}%
                    </div>
                </template>
                <template v-slot:cell(division)="row">
                    <div>
                        {{ row.item.division_name }}
                    </div>
                </template>
                <template v-slot:cell(warehouse)="row">
                    <div class="small">
                        Gudang: {{ row.item.warehouse_name }}
                    </div>
                    <div class="small text-muted" v-if="row.item.details_count != null">
                        {{ row.item.details_count }} unit barang
                    </div>
                </template>
                <template v-slot:cell(group)="row">
                    <div>
                        {{ row.item.group_name }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{ getStatusBadge(row.item.status)[1]
                    }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link v-if="row.item.status == 1" :to="'flash-sale/' + row.item.id">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lanjut Draft">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link v-if="[2, 3, 0].includes(row.item.status)" :to="'flash-sale/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Flash Sale">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Flash Sale Baru" centered no-close-on-backdrop hide-footer>
            <b-form-group
                description="Masukkan nama unik untuk flash sale. Nama ini akan digunakan sebagai identitas utama dan tidak boleh sama dengan flash sale lain.">
                <div>Nama Flash Sale <span style="color: red;">*</span></div>
                <b-form-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group>
                <div>Deskripsi <span style="color: red;">*</span></div>
                <b-form-input v-model="input.description" maxlength="100" />
            </b-form-group>
            <b-form-group label="Pilih Gudang">
                <multiselect v-model="input.warehouse" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optWarehouse" />
            </b-form-group>
            <b-form-group label="Divisi">
                <multiselect v-model="input.division" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optDivisions" />
            </b-form-group>
            <b-form-group label="Group">
                <multiselect v-model="input.group" label="name" track-by="id" :internal-search="true" deselect-label=""
                    select-label="" :options="optGroups" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="createFlashSale">
                    {{ isSubmitting ? "Membuat..." : "Buat Flash Sale" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-calculate" title="Perhitungan Totalan" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.warehouseFrom != null && calculateTotalData.warehouseTo != null">
                    Asal: <strong>{{ calculateTotalData.warehouseFrom }}</strong><br />
                    Tujuan: <strong>{{ calculateTotalData.warehouseTo }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Faktur: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang: <strong>{{ calculateTotalData.total_items }}</strong> barang
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            calculateTotalData: {},

            filter: {
                status: -1,
                name: "",
                warehouse: "",
                division: "",
                group: 1
            },

            input: {
                name: "",
                description: "",
                warehouse: null,
                division: null,
                group: null
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "name", label: "Nama Flash Sale" },
                { key: "division", label: "Divisi" },
                { key: "warehouse", label: "Gudang" },
                { key: "group", label: "Group" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Aktif" },
                { value: 3, text: "Terjual" },
                { value: 0, text: "Tidak Aktif" }
            ],

            optFilterWarehouse: [],
            optWarehouse: [],
            optFilterDivision: [],
            optDivisions: [],
            optFilterGroup: [],
            optGroups: [],

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optFilterWarehouse = [
                    { value: "", text: "Semua" }
                ]
                res.data.data.map(item => {
                    this.optFilterWarehouse.push({
                        value: item.id,
                        text: item.name + " - " + item.office_name
                    })
                    this.optWarehouse.push({
                        id: item.id,
                        name: item.name + " - " + item.office_name
                    })
                })
            })

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                this.optFilterDivision = [
                    { value: "", text: "Semua" }
                ]
                res.data.data.map(item => {
                    this.optDivisions.push({
                        id: item.id,
                        name: item.name
                    })

                    this.optFilterDivision.push({
                        value: item.id,
                        text: item.name
                    })
                })
            })

            let getGroups = this.$axios.get("master/flash-sale-groups", {
                params: {
                    all: 1
                }
            }).then(res => {
                res.data.data.map(item => {
                    this.optFilterGroup.push({
                        value: item.id,
                        text: item.name
                    })
                    if (item.is_visible) {
                        this.optGroups.push({
                            id: item.id,
                            name: item.name
                        })
                    }
                })
            })

            Promise.all([getItems, getWarehouses, getDivisions, getGroups]).then(() => {
                this.initStatus = 1
                if (!this.filter.division) {
                    this.filter.division = "";
                }
                if (!this.filter.warehouse) {
                    this.filter.warehouse = "";
                }
            })
                .catch(() => {
                    this.initStatus = -1
                })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            const params = {
                page: this.currentPage,
                per_page: this.perPage,
                group_id: this.filter.group || undefined,
                name: this.filter.name || undefined,
                status: this.filter.status !== -1 ? this.filter.status : undefined,
                warehouse_id: this.filter.warehouse || undefined,
                division_id: this.filter.division || undefined,
                sortBy: this.sortBy || undefined,
                sortDesc: this.sortDesc || undefined
            };

            return this.$axios.get("flash-sale", { params }).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        createFlashSale() {
            if (this.input.name.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi nama flash sale!")
            }

            if (this.input.description.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi deskripsi flash sale!")
            }

            if (this.input.warehouse == null) {
                return this.$helper.toastError(this, "Mohon memilih gudang!")
            }

            if (this.input.division == null) {
                return this.$helper.toastError(this, "Mohon memilih divisi!")
            }

            if(this.input.group == null) {
                return this.$helper.toastError(this, "Mohon memilih group!")
            }

            this.isSubmitting = true
            let payload = {
                name: this.input.name,
                description: this.input.description,
                warehouse_id: this.input.warehouse.id,
                division_id: this.input.division.id,
                group_id: this.input.group ? this.input.group.id : null
            }

            this.$axios.post("flash-sale", payload).then(res => {
                let data = res.data.data
                this.$bvModal.hide("m-create")
                this.$router.push({ path: "flash-sale/" + data.id })

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch (status) {
                case 1: return ["dark", "DRAFT"]
                case 2: return ["primary", "AKTIF"]
                case 3: return ["success", "TERJUAL"]
                case 0: return ["danger", "TIDAK AKTIF"]
                default: return ["light", "-"]
            }
        },

        calculateTotal() {

            let warehouseFilled = this.filter.warehouseFrom != "" && this.filter.warehouseTo != ""
            let dateFilled = this.filter.startDate != "" || this.filter.endDate != ""

            if (!warehouseFilled && !dateFilled) {
                return this.$helper.toastError(this, "Mohon mengisi minimal filter warehouse atau tanggal perpindahan!")
            }

            let param = ""

            if (this.filter.warehouseFrom != null && this.filter.warehouseTo != null) {
                param += "&filterWarehouseTo=" + this.filter.warehouseTo
                param += "&filterWarehouseFrom=" + this.filter.warehouseFrom
            }

            if (!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if (!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            this.isSubmitting = true
            this.$bvModal.show("m-calculate")

            this.$axios.get("move-warehouse/calculate?" + param).then(res => {
                this.calculateTotalData = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.$bvModal.hide("m-calculate")
                })
                .finally(() => this.isSubmitting = false)
        }

    },

    created() {
        this.init()
        this.$helper.toastFlash(this)
    }
}
</script>
